import { StatusE } from '@enums/protocol.enum';
import { TeamI } from './team.interface';
import { UserI } from './user.interface';
import { ChannelI } from './channel.interface';

export interface TabulationI {
  _id?: string;
  customerId?: string;
  user?: UserI | string;
  name: string;
  description: string;
  teams?: TeamI[] | string[];
  tabulationsDaughters?: TabulationI[];
  status: StatusE;
  createdAt: string;
  updatedAt: string;
  countChats?: number;
  countCalls?: number;
  parentId?: string;
  level?: number;
  channels?: ChannelI[] | string[];
}

export enum SortOrderE {
  ascending = 'ascending',
  descending = 'descending',
}

export type FilterI = {
  customer: string;
  query: {
    filter?: string;
    pageSize?: number;
    lastKey?: string;
    direction?: SortOrderE;
  };
};

export interface TeamCheckedI {
  team: TeamI;
  checked: boolean;
}

export type TypeFilterReportTabulation = {
  tabulation?: string;
  created_by?: string;
  assigned_by?: string;
  assigned_by_start_date?: string;
  assigned_by_end_date?: string;
  status?: string;
  type: 'ALL' | 'CHAT' | 'CALL';
  channel?: string;
  teams?: string;
  costCenters?: string;
};

export enum TabulationLevelE {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
  FOURTH = 4,
  FIFTH = 5,
}

export type TabulationFilters = {
  search?: string;
  sort: string;
  active: string;
  limit: number;
  page: number;
  status?: string;
  team?: string | string[];
  teams?: string;
  level?: string;
  channel?: string;
  empyChannels?: boolean;
};

export interface CreateTabulationI {
  tabulationIds: string[];
  commentTabulation?: string;
}
